import { useEffect, useRef, useState, type MouseEvent } from 'react';
import { MENU_CLOSE_DELAY_MS } from './constatnts';

const DropdownMenu = () => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const clearCloseTimer = () => {
    if (closeTimerRef.current != null) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimerRef.current = setTimeout(() => {
      setAnchorEl(null);
      closeTimerRef.current = null;
    }, MENU_CLOSE_DELAY_MS);
  };

  useEffect(() => () => clearCloseTimer(), []);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    clearCloseTimer();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    clearCloseTimer();
    setAnchorEl(null);
  };

  return {
    anchorEl,
    buttonRef,
    clearCloseTimer,
    handleClose,
    handleOpen,
    open,
    rootRef,
    scheduleClose,
    setAnchorEl,
  };
};

export default DropdownMenu;
